import { render, staticRenderFns } from "./InstantPaymentHandler.vue?vue&type=template&id=08ff60c6&scoped=true"
import script from "./InstantPaymentHandler.vue?vue&type=script&lang=js"
export * from "./InstantPaymentHandler.vue?vue&type=script&lang=js"
import style0 from "./InstantPaymentHandler.vue?vue&type=style&index=0&id=08ff60c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff60c6",
  null
  
)

export default component.exports